<template>
    <div class="flex flex-row mt-10 px-4">
        <div class="w-1/2">
            <h1 class="font-serif font-semibold text-6xl text-black pl-1 mb-4">Fascículos</h1>
            <ul class="inline-flex flex-row flex-wrap gap-4">
                <li class="w-[calc(20%-1rem)]" v-for="(issue, index) in issues" :key="issue.slug">
                    <div v-if="issue.published" @click="changeTab(index)" class="p-2 text-center cursor-pointer grow h-[22rem] hover:outline hover:outline-1">
                        <img :src="require(`@/assets/img/fa0${index + 1}/fa0${index + 1}_capa.jpg`)" alt="Capa do fascículo" />
                        <p class="font-light uppercase text-sm">Fascículo #{{ index + 1 }}</p>
                        <p class="font-serif font-semibold text-lg">
                            {{ issue.title }}
                        </p>
                    </div>
                    <div v-else class="text-center p-2">
                        <img :src="require(`@/assets/img/home/capa_placeholder.png`)" alt="Capa do fascículo" />
                        <p class="font-light uppercase text-sm opacity-40">Fascículo #{{ index + 1 }}</p>
                        <p class="font-serif font-semibold text-lg opacity-40">
                            {{ issue.title }}
                        </p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="w-1/2 mt-16">
            <div v-if="this.currentTab != null">
                <img class="object-cover h-96 w-full" :src="require(`@/assets/img/fa0${this.currentTab + 1}/fa0${this.currentTab + 1}_banner.jpg`)" alt="Banner do fascículo" />
                <div class="flex flex-row">
                    <h2 class="font-serif font-semibold text-3xl border-b my-2 pb-2 grow mr-8">
                        {{ issues[this.currentTab].title }}
                    </h2>
                    <a target="_blank" :href="`${publicPath}static/pdf/Fapesp60_fasciculo0${this.currentTab + 1}.pdf`" class="mr-2">
                        <img class="mt-8 h-12 w-auto opacity-80" :src="require(`@/assets/img/pdf-icon.svg`)" :alt="`Baixar PDF do fascículo`" />
                    </a>
                </div>
                <div class="flex flex-row">
                    <div class="w-1/2">
                        <h3 class="font-light uppercase">Artigos</h3>
                        <ul>
                            <li v-for="post in issues[this.currentTab].posts" :key="post.slug">
                                <p v-if="post.author != null" class="text-xl mb-0.5">
                                    <router-link class="font-serif font-semibold" :to="`/${issues[currentTab].slug}/${post.postSlug}`">{{ post.postTitle }}</router-link>
                                </p>
                                <p v-if="post.author != null" class="mb-2">
                                    {{ post.author }}
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div class="w-1/2">
                        <h3 class="font-light uppercase">Reportagens</h3>
                        <ul>
                            <li v-for="post in issues[this.currentTab].posts" :key="post.slug">
                                <p v-if="post.author == null" class="text-xl mb-2">
                                    <router-link class="font-serif font-semibold" :to="`/${issues[currentTab].slug}/${post.postSlug}`">{{ post.postTitle }}</router-link>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['issues'],

    data() {
        return {
            currentTab: null,
            publicPath: process.env.BASE_URL,
        }
    },
    created: {},
    methods: {
        changeTab: function (chosenTab) {
            this.currentTab = chosenTab
        },
    },
    watch: {
        currentTab: function () {},
    },
}
</script>

<style></style>
